import { Component, ViewEncapsulation } from '@angular/core';
import { AppState } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
import { HttpUtils } from '../../../common/http/http-utils';
import { VcaAlertsService } from "../../../common/vca-alerts/vca-alerts.service";
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { formatDateTimeCustom } from '../../../common/utils/utils';
import { HttpClient, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Component({
    selector: 'dashboard-mini-activity-log',
    styles: [require('./activity-log.scss')],
    template: require('./dashboard-mini-activity-log.html'),
    encapsulation: ViewEncapsulation.None
})

export default class DashboardMiniActivityLog {
    private url: string = '/hybridity/api/jobsForActivityLog?pageSize=5';
    private subscription;
    private loading: boolean = true;
    private value: string = '';
    private jobs = [];

    constructor(public appState: AppState, public translate: TranslateService, public http: HttpClient,
                public alerts: VcaAlertsService) {
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnInit() {
        this.subscribeForJobs();
    }

    pollJobs() {
        return this.http.get(HttpUtils.getBaseUrl() + this.url).map(
            res => res
        );
    }

    subscribeForJobs() {
        this.loading = true;
        this.subscription = this.pollJobs().subscribe(
            data => {
                this.getJobs(data);
                this.loading = false;
            },
            error => {
                this.loading = false;
                this.alerts.danger(['Failed to retrieve Jobs', error], 'dashboard');
            }
        );
    }

    getJobs(res) {
        this.loading = true;
        this.jobs.length = 0;
        let jobsArray: Array<Object> = [];
        if (res && res.data && res.data.activityLogs) {
            jobsArray = res.data.activityLogs;
        }
        for (let job of jobsArray) {
            if (job) {
                if (job['isDone']) {
                    if (job['didFail']) {
                        job['status'] = 'failure';
                    } else {
                        job['status'] = 'success';
                    }
                } else {
                    job['status'] = 'running';
                }
            }
            job['description_short'] = this.truncateString(job['description']);

            this.jobs.push(job);
        }
        this.loading = false;
    }

    truncateString(str, truncateLength = 45) {
        if (str && truncateLength && str.length > truncateLength) {
            return str.substring(0, 41) + '...';
        } else {
            return str;
        }
    }

    formatDateTime(timeStamp) {
        return formatDateTimeCustom(timeStamp);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-log/dashboard-mini-activity-log.component.ts